import React, { useState } from 'react';
import { API_ENDPOINTS } from '../settings';
import Notification, { notifyInfo, notifySuccess, notifyError } from '../popups/Notification';

const Reports = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const [fileName, setFileName] = useState('');

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
                notifyError('Please select a valid CSV file');
                event.target.value = '';
                return;
            }
            setSelectedFile(file);
            setFileName(file.name);
        }
    };

    const handleClearFile = () => {
        setSelectedFile(null);
        setFileName('');
        const fileInput = document.getElementById('doordash-csv-input');
        if (fileInput) {
            fileInput.value = '';
        }
    };

    const handleProcess = async () => {
        if (!selectedFile) {
            notifyError('Please select a CSV file first');
            return;
        }

        setIsProcessing(true);
        notifyInfo('Processing DoorDash billing report...');

        try {
            const authTokens = JSON.parse(localStorage.getItem('authTokens'));
            const formData = new FormData();
            formData.append('file', selectedFile);

            const response = await fetch(API_ENDPOINTS.DOORDASH_BILLING_REPORT, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${authTokens.access}`,
                },
                body: formData,
            });

            if (response.ok) {
                const data = await response.json();
                notifySuccess(data.message || 'DoorDash billing report processed successfully. Email will be sent shortly.');
                handleClearFile();
            } else {
                const errorData = await response.json();
                notifyError(errorData.error || 'Failed to process DoorDash billing report');
            }
        } catch (error) {
            console.error('Error processing DoorDash billing report:', error);
            notifyError('An error occurred while processing the report');
        } finally {
            setIsProcessing(false);
        }
    };

    return (
        <>
            <Notification />
            <div className="container-fluid px-2 px-md-4">
                <div className="page-header min-height-10 border-radius-xl mt-4">
                    <h3>Reports</h3>
                    <p className="text-sm text-secondary m-3">Generate and verify billing reports</p>
                </div>

                <div className="row mt-4">
                    <div className="col-lg-6 col-md-8 col-12">
                        <div className="card">
                            <div className="card-header pb-0 px-3">
                                <div className="d-flex align-items-center mb-2">
                                    <i className="material-icons text-primary me-2" style={{ fontSize: '24px' }}>fact_check</i>
                                    <h6 className="mb-0">Check DoorDash Billing Report</h6>
                                </div>
                                <p className="text-sm text-secondary mb-0">
                                    Upload a DoorDash billing CSV file to verify and reconcile charges. A verification report will be sent via email.
                                </p>
                            </div>
                            <div className="card-body pt-4 px-3">
                                <div className="mb-3">
                                    <label htmlFor="doordash-csv-input" className="form-label text-sm text-dark fw-bold mb-2">
                                        Select CSV File
                                    </label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        id="doordash-csv-input"
                                        accept=".csv"
                                        onChange={handleFileChange}
                                        disabled={isProcessing}
                                    />
                                    {fileName && (
                                        <div className="d-flex align-items-center mt-2">
                                            <span className="badge bg-gradient-info">
                                                <i className="material-icons text-sm me-1" style={{ verticalAlign: 'middle', fontSize: '14px' }}>description</i>
                                                {fileName}
                                            </span>
                                            <button
                                                type="button"
                                                className="btn btn-link text-danger p-0 ms-2"
                                                onClick={handleClearFile}
                                                disabled={isProcessing}
                                                style={{ lineHeight: 1 }}
                                            >
                                                <i className="material-icons" style={{ fontSize: '18px' }}>close</i>
                                            </button>
                                        </div>
                                    )}
                                </div>

                                <div className="d-flex justify-content-end mt-4">
                                    <button
                                        type="button"
                                        className="btn bg-gradient-primary mb-0"
                                        onClick={handleProcess}
                                        disabled={!selectedFile || isProcessing}
                                    >
                                        {isProcessing ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Processing...
                                            </>
                                        ) : (
                                            <>
                                                <i className="material-icons me-1" style={{ verticalAlign: 'middle', fontSize: '16px' }}>send</i>
                                                Process Report
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Reports;
